import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '../Button';
import * as styles from './LinkButton.scss';

/**
 * Reusable Component with <Link /> Wrapper Around <Button /> for `Open Link in New Tab` Feature
 * @function LinkButton
 * @param {Object} props
 * @return {ReactElement}
 */
const LinkButton = ({ buttonProps, className, style, linkData }) => {
  return (
    <Link className={className} to={{ pathname: linkData.pathname, state: linkData.state }} style={style}>
      <Button {...buttonProps} />
    </Link>
  );
};

LinkButton.propTypes = {
  buttonProps: PropTypes.shape({
    className: PropTypes.string,
    click: PropTypes.func,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
    svgLeft: PropTypes.bool,
    svgRight: PropTypes.bool,
    svg: PropTypes.node,
    text: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  linkData: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.objectOf(PropTypes.any),
  }).isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default LinkButton;
